import script from "./IconPNG.vue?vue&type=script&lang=js"
export * from "./IconPNG.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__